module.exports = __webpack_public_path__ + "static/UBI-Vector4.940f6afd.svg";